import { Typography } from "antd";
import styled from "styled-components";

export const ChartWrapper = styled.div`
  display: flex;
  width: 143px;
  height: 143px;
`;

export const StatisticWrapper = styled.div`
  display: flex;
  width: 31.5%;
  height: 236px;
  padding: 24px;
  background: rgb(255, 255, 255);
  box-shadow: rgba(24, 39, 75, 0.04) 0px 8px 22px -6px,
    rgba(24, 39, 75, 0.04) 0px 14px 64px -4px;
  border-radius: 16px;
  flex-wrap: wrap;
  align-content: space-between;
`;

export const StyledText = styled(Typography.Text)`
  font-weight: 600;
  font-size: 24px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 45%;
  align-content: space-between;
`;

export const DataWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
